module.exports = __webpack_public_path__ + "img/product-preview-24.9679ee7.png";